"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    // ======================================================
    app: {
      about: 'About',
      actions: {
        add: 'Add',
        addNamed: 'Add {name}',
        remove: 'Delete',
        removeNamed: 'Delete {name}',
        removeConfirmation: 'Please confirm deletion',
        more: 'More',
        less: 'Less',
        download: 'Download',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        moreFormFields: 'More Fields',
        export: 'Export',
        edit: 'Edit',
        detail: 'Detail',
        next: 'Next',
        back: 'Back',
        start: 'Start',
        previous: 'Previous',
        whatNext: 'What next...',
        confirm: 'Confirm',
        search: 'Search',
        userProfile: 'User Profile',
        tenantProfile: 'Your CRM profile',
        imports: 'Imports',
        fileImports: 'File Transfers',
        settings: 'Settings',
        logout: 'Logout',
        login: 'Login',
        filterList: 'Filter list',
        excel: 'Excel',
        refresh: 'Refresh',
        clear: 'Clear',
        agree: 'Agree',
        disagree: 'Disagree',
        makeCopy: 'Make a copy',
        fullscreen: 'Full Screen',
        fullscreenClose: 'Close Full Screen',
        dragNDropNClick: "Drag 'n' drop some files here, or click to select files",
        copy: 'Copy'
      },
      messages: {
        confirmRemove: 'Do you really want remove this item?',
        errorOccurred: 'An error occurred',
        createdSuccess: 'Creation succeeded.',
        savedSuccess: 'Saving succeeded.',
        deletedSuccess: 'Deletion succeeded.',
        uploadSuccess: 'Files uploaded successfully.',
        uploadError: 'Error during file upload.',
        uploadInProgress: 'Upload In Progress...',
        uploadedFiles: '{number, plural, one {1 file} other {{number} files}} were uploaded'
      },
      error: 'Error!',
      validations: {
        isRequired: 'A {field} is required.',
        minLengthIsRequired: 'At least {number, plural, one {1 item} other {{number} items}} required.',
        minValue: 'Minimum allowed value is {value}.',
        maxValue: 'Maximum allowed value is {value}.',
        passwordMatchError: 'Password confirmation not match.',
        invalidEmail: 'Invalid email address.',
        invalidPhoneNumber: 'Invalid phone number. Phone number in format "+X XXX XXX XXX".',
        notValidNumber: 'Not valid number',
        invalidUrl: 'Invalid URL.',
        positive: 'Number have to be positive.',
        negative: 'Number have to be negative.'
      },
      login: {
        title: 'Sprinx CRM Login',
        username: 'Username',
        password: 'Password',
        loginButton: 'Login',
        error: 'Login failed. User name or password not found.',
        pleaseRelogin: 'It seems that You are not authenticate. Please authenticate again.'
      },
      days: '{count, plural, one {1 day} other {{formattedCount} days}}',
      // values { count, formattedCount}
      overdue: '{count, plural, one {1 day} other {{formattedCount} days}} overdue',
      // values { count, formattedCount}
      newItem: 'New',
      anonymizing: {
        confirm: {
          title: 'Confirm anonymization',
          content: 'Are you sure you want to anonymize personal data?'
        },
        button: 'Anonymize personal data'
      },
      appMenu: {
        discover: 'Discover'
      },
      missingType: 'Please define some {typeName} in application settings first.',
      missingTypeForEntityType: 'Please define some {typeName} for {forEntityTypeName} in application settings first.',
      emptyScoringBlog: 'Modules whose content or settings are displayed on this page are not activated.'
    },
    // ======================================================
    components: {
      buttons: {
        showOnMap: 'Show on map'
      },
      filters: {
        filterButtonSubmit: 'Search',
        filterFieldName: '{name} ({conditionType})',
        addCondition: 'Add condition',
        resetFilter: 'Reset filter',
        operators: {
          contains: {
            _: 'contains',
            0: 'contains'
          },
          containsexact: {
            _: 'contains exact',
            0: 'contains exact'
          },
          notcontains: {
            _: 'not contains',
            0: 'not contains'
          },
          betweennumber: {
            _: 'between',
            0: 'from',
            1: 'to'
          },
          betweendate: {
            _: 'between',
            0: 'from',
            1: 'to'
          },
          equal: {
            _: 'is equal',
            0: 'is equal'
          }
        }
      },
      paginationList: {
        itemsTotal: 'Total items: {number}',
        nextPage: 'Load next {number} items',
        emptyMessage: 'No items found.'
      },
      selects: {
        emptyOption: 'None',
        emptyMessage: 'No items found.'
      },
      tables: {
        labelRowsPerPage: 'Rows per page',
        sortBy: 'Sort by {field}',
        recordsChanged: 'Some records have been added or changed.'
      },
      textField: {
        errorMsgWrapper: 'Error: {msg}'
      },
      dateField: {
        invalidDateFormat: 'Invalid Date Format.',
        invalidDate: 'Unknown',
        maxDateMessage: 'Date should not be after maximal date.',
        minDateMessage: 'Date should not be before minimal date.',
        today: 'Today'
      },
      detailNavigation: {
        scoringblog: 'Scoring Blog',
        card: 'Card',
        relations: 'Relations'
      },
      manipulationInfo: {
        created: 'Created',
        updated: 'Updated',
        removed: 'Removed'
      }
    }
  }
};
var _default = messages;
exports.default = _default;